@use '../../variables.scss' as *;

.datasheet_container {
    display: flex;
    flex-direction: column;
    gap: calc($default-spacing / 2);

    .datasheet_hint {
        padding-top: 10px;
        padding-bottom: 8px;
    }

    .link_button {
        border: none;
        background-color: $light-grey;
        transition: background-color 300ms;
        border-radius: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-right: 8px;
        margin-bottom: 8px;
        height: 48px;
        position: relative;
        max-width: 350px;
        color: $es-all-black;
        font-size: 13px;

        .link_title {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 0 24px;

            .link_icon {
                display: flex;
                align-items: center;

                svg {
                    display: block;
                    height: 24px;
                    fill: $es-all-black;
                }
            }

            .link_label {
                margin-left: 12px;
                font-weight: 500;
                line-height: 24px;
            }
        }

        &:hover {
            background-color: $mid-grey;
            color: $dp-black;
        }
    }

    .datasheet_modal_content {
        display: flex;
        flex-direction: column;

        .link_button {
            margin-left: 8px;
        }
    }

    :global(body.drs-scroll-lock) {
        overflow: hidden;
        /* !important is required so the modal scroll lock can override global body styles on mobile. */
        position: fixed !important;
        left: 0;
        right: 0;
        width: 100%;
        touch-action: none;
    }
    

    
    @media only screen and (min-width: $breakpoint-tablet-min-width) {
        .modal_open_button {
            width: 50%;
        }
    }
}